// AsyncStorage API over localStorage; never throws (private mode, blocked storage).
// Per-account keys (chat read markers) are scoped to the signed-in uid: see lib/storageKeys.js.
import { auth } from "../firebase.web";
import { scopeStorageKey } from "../lib/storageKeys";

const safe = (fn, fallback = null) => { try { return fn(); } catch { return fallback; } };
const scoped = (key) => scopeStorageKey(key, auth.currentUser?.uid || null);

const AsyncStorage = {
  async getItem(key) {
    const k = scoped(key);
    return k == null ? null : safe(() => window.localStorage.getItem(k));
  },
  async setItem(key, value) {
    const k = scoped(key);
    if (k != null) safe(() => window.localStorage.setItem(k, value));
  },
  async removeItem(key) {
    const k = scoped(key);
    if (k != null) safe(() => window.localStorage.removeItem(k));
  },
};

export default AsyncStorage;
